// extracted by mini-css-extract-plugin
module.exports = {"defaultIconStyle":"az_am","fontSizeInherit":"az_bm","fontSizeSmall":"az_cm","fontSizeLarge":"az_dm"};